let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Hi3h")).then(() => parcelRequire('3rrmj'));